import React, { ChangeEvent, useCallback } from "react"
import { debounce } from "throttle-debounce"

import { useFilterContext } from "~/components/FilterWrapper/FilterWrapper"
import { Input } from "~/components/Input/Input"

type Props = {
  isSortFilter?: boolean
  placeholder: string
}

export const NameFilter: React.FC<Props> = ({ placeholder, isSortFilter }) => {
  const { updateFilterState, filterState } = useFilterContext()
  // TODO: повесить тротл обратно (ломает работу фильтра с адресной строкой - сбрасывает state для других фильтров на изначальные значения)
  // const throttledOnChange = useCallback(debounce(250, onChange), [])

  const onChange = (e: ChangeEvent<HTMLInputElement>): void => {
    const searchQueryLength = e.target.value.replace(/\s/g, "").length

    if (searchQueryLength === 0) {
      updateFilterState({ search: "", sort: undefined })

      return
    }

    updateFilterState({ search: e.target.value, sort: isSortFilter ? "relevance" : undefined })
  }

  return <Input defaultValue={filterState.search} label={placeholder} onChange={onChange} />
}
